import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/utils.helpers";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/mon-compte";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate(next);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-x py-20 max-w-md" data-testid="login-page">
      <p className="overline text-[#2B8B8E]">Connexion</p>
      <h1 className="text-4xl font-light mt-2 mb-8">Bon retour parmi nous.</h1>
      <form onSubmit={submit} className="space-y-4 border border-border rounded-3xl p-7 bg-card">
        <GoogleAuthButton label="Continuer avec Google" testId="login-google-btn" />
        <div className="relative flex items-center py-1">
          <div className="flex-grow border-t border-border"></div>
          <span className="mx-3 text-[10px] uppercase tracking-widest text-muted-foreground">ou</span>
          <div className="flex-grow border-t border-border"></div>
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <Label>Mot de passe</Label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        <Button type="submit" disabled={submitting} className="w-full bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full" data-testid="login-submit">
          {submitting ? "Connexion…" : "Se connecter"}
        </Button>
        <p className="text-xs text-center text-muted-foreground">
          Pas encore de compte ? <Link to="/inscription" className="text-[#2B8B8E] hover:underline">Créer un compte</Link>
        </p>
      </form>
    </div>
  );
}
